import { withStyles } from '@material-ui/core/styles';
import { ToggleButtonGroup } from '@material-ui/lab';

const StyledToggleButtonGroup = withStyles((theme) => ({
  root: {
    width: '100%',
    borderRadius: 4,
    backgroundColor: 'white',

    [theme.breakpoints.up('sm')]: {
      borderRadius: 50,
    },
  },
}))(ToggleButtonGroup);

export default StyledToggleButtonGroup;
